import { render } from "./LogIn.vue?vue&type=template&id=4d8709e6"
import script from "./LogIn.vue?vue&type=script&lang=js"
export * from "./LogIn.vue?vue&type=script&lang=js"

import exportComponent from "/home/nata/programming/WebProjects/DjangoVueEcommerce/djackets_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__